<script setup lang="ts">
import { computed, defineProps } from "vue";

type Props = {
  buttonText: string;
  isLoading: boolean;
};

const props = defineProps<Props>();
const buttonIsLoading = computed(() => props.isLoading);
</script>

<template>
  <button
    :disabled="buttonIsLoading"
    class="bg-[#393840] border border-[#393840] w-[150px] rounded-primary-radius p-3 flex items-center justify-center text-white text-base leading-5 tracking-[0.01rem] font-semibold"
    :class="`${buttonIsLoading ? 'cursor-wait' : ''}`"
  >
    <svg
      v-if="buttonIsLoading"
      width="16"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :class="`${buttonIsLoading ? 'animate-spin' : ''}`"
    >
      <path
        d="M5.50024 11H1.75024V14.75M8.50024 5H12.2502V1.25M1.4375 5.75255C1.85801 4.71175 2.56207 3.80978 3.46966 3.14917C4.37724 2.48856 5.45289 2.09564 6.57256 2.01538C7.69223 1.93512 8.81129 2.17055 9.80382 2.69496C10.7963 3.21937 11.6212 4.0119 12.1858 4.98209M12.5634 10.2478C12.1429 11.2886 11.4388 12.1906 10.5312 12.8512C9.62367 13.5118 8.54912 13.9042 7.42944 13.9845C6.30977 14.0647 5.18979 13.8293 4.19727 13.3049C3.20474 12.7805 2.37936 11.9881 1.8147 11.0179"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span v-else>
      {{ buttonText }}
    </span>
  </button>
</template>
